import { render, staticRenderFns } from "./PiedDePage.vue?vue&type=template&id=6b35c5e2&"
import script from "./PiedDePage.vue?vue&type=script&lang=js&"
export * from "./PiedDePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports